import { NotificationParams } from '/@src/models/api'
import { postOmniNotificationKv } from '/@src/api/notificationRepo'
import useApi, { useApollo } from '/@src/composable/useApi'
import { OmniNotificationFormParams } from '/@src/components/pages/forms/content/NotificationForm.vue'
import {
  PushBroadcastCreateDocument,
  PushPlatform,
} from '/@src/__generated__/generated-gql-types'

export default function useNotification() {
  const api = useApi()
  const apollo = useApollo()
  const sendNotificationData = async (param: NotificationParams) => {
    const platform = {
      all: PushPlatform.All,
      android: PushPlatform.Android,
      ios: PushPlatform.Ios,
    }[param.platform || 'all'] || PushPlatform.All

    const { data } = await apollo.mutate({
      mutation: PushBroadcastCreateDocument,
      variables: {
        title: param.title,
        body: param.body || '',
        platform,
        subtitle: param.subtitle,
        startTime: param.start_time || undefined,
        expireTime: param.expire_time || undefined,
        extra: param.extra?.url ? { url: param.extra.url } : undefined,
      },
    })

    return data?.pushBroadcastCreate
  }

  const settingOmniNotificationKvData = (param: OmniNotificationFormParams) => {
    return postOmniNotificationKv(api, param)
  }

  return {
    sendNotificationData,
    settingOmniNotificationKvData,
  }
}
